import { toastr } from 'react-redux-toastr';

export const mapErrorToToast = (error) =>
  error.title
    ? toastr.error(error.title, error.message)
    : toastr.error(error.message);
